<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card title="Gif Yükle">
          <pre-loading v-if="uploading" />
          <template v-else>
            <!-- Eğer gif mevcutsa resmi görüntülemek için b-img kullanıyoruz -->
            <b-img
              v-if="itemData.image"
              :src="baseURL + '/media/sectors/' + itemData.image"
              alt="Gif"
              fluid
              class="mb-3"
            />
            <b-form-file
              id="gif-file"
              v-model="image"
              class="mt-1"
              placeholder="Bir dosya seçin veya buraya bırakın..."
              drop-placeholder="Dosyayı buraya bırakın..."
              browse-text="Dosya Seçin"
            />
            <div class="mt-1">
              <b-button
                variant="primary"
                :disabled="!image"
                @click="uploadFile"
              >
                <FeatherIcon icon="UploadIcon" />
                Gif Yükle
              </b-button>
            </div>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BButton, BCard, BCol, BRow, BFormFile, BImg,
} from 'bootstrap-vue'
import PreLoading from '@/layouts/components/common/PreLoading.vue'

export default {
  name: 'GifUploadCard',
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
    BFormFile,
    BImg,
    PreLoading,
  },
  data() {
    return {
      baseURL: this.$store.state.app.baseURL,
      image: null,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['sectors/dataItem']
    },
    uploading() {
      return this.$store.getters['fileUpload/uploading']
    },
  },
  methods: {
    uploadFile() {
      this.$store.dispatch('fileUpload/uploadFile', {
        upload_file: this.image, // formData nesnesini gönderin
        folder: 'sectors',
      })
        .then(response => {
          if (response.status) {
            this.itemData.image = response.filename
            console.log('Dosya başarıyla yüklendi:', response.filename)
          } else {
            console.error('Dosya yükleme başarısız:', response)
          }
        })
        .catch(error => {
          console.error('Dosya yükleme hatası:', error)
        })
    },
  },
}
</script>
